/* kn-tweaks — chinh nho tren trang san pham, bat/tat bang metafield (custom.pack_unit / custom.hide_offer_box / custom.default_pack)
   1) Bo tien to "Color: " / "Size: " trong dropdown cua cac dong chon trong combo.
   2) Ten pack: bo "Combo N — ", them so luong "· 2 vests" (don vi lay tu custom.pack_unit), the ghep them "1 ".
   3) Combo ghep: gap mo ta san pham ghep them sau dong "Description v".
   4) Chon san pack theo custom.default_pack (vd "2").
   Khung MULTI-BUY duoc an bang <style> trong <head> (meta-tags.liquid), khong can JS. */
(function () {
  var cfg = window.KN_PRODUCT || {};
  var root = document.querySelector('[data-packs]') || document;

  /* 1) bo "Nhan: " o dau option — chay lai moi khi combo clone/ve lai dong chon */
  function stripLabels() {
    var opts = root.querySelectorAll('.kp-pick select option, .kp-select option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], t = o.textContent;
      var m = /^\s*[^:]{1,30}:\s+(.+)$/.exec(t);
      if (m && m[1] && m[1] !== t) o.textContent = m[1];
    }
  }

  /* 2) ten pack: bo tien to "Combo N — " (user bo chu Combo 16/10), roi them so luong "· 2 vests"
        tru khi ten da co san (vd "Buy 1 Vest"). Chay cho ca the combo ghep (kn-bundle) khi no duoc them vao. */
  function qtySuffix() {
    var unit = (cfg.packUnit || '').trim();
    var packs = root.querySelectorAll('label.kp-pack');
    for (var i = 0; i < packs.length; i++) {
      var p = packs[i];
      var hd = p.querySelector('.kp-pack-hd'); if (!hd) continue;
      var title = hd.querySelector('.kp-pack-title, .kp-pack-name, b, strong') || hd.firstElementChild || hd;
      var card = p.closest('.kp-pk');
      var isBundle = (card && card.hasAttribute('data-bundle')) || p.classList.contains('kp-bundle-row'); /* data-bundle nam o the ngoai (.kp-pk), khong o label */
      var tn = title.firstChild;
      if (tn && tn.nodeType === 3 && /^\s*Combo\s*\d+\s*[—–-]\s*/i.test(tn.nodeValue)) {
        tn.nodeValue = tn.nodeValue.replace(/^\s*Combo\s*\d+\s*[—–-]\s*/i, '');
        /* the combo ghep: "Shaping Vest + 60-Day..." -> "1 Shaping Vest + 60-Day..." (user 16/10) */
        if (isBundle && !/^\d/.test(tn.nodeValue)) tn.nodeValue = '1 ' + tn.nodeValue;
      }
      if (!unit || isBundle || p.querySelector('.kp-pack-qty')) continue;
      var inp = p.querySelector('input[name="kp-pack"]'); var q = inp ? parseInt(inp.value, 10) : NaN;
      if (!(q > 0)) continue;
      var plural = q + ' ' + unit + (q === 1 ? '' : 's');
      if (title.textContent.toLowerCase().indexOf(plural.toLowerCase()) !== -1) continue;
      var s = document.createElement('span'); s.className = 'kp-pack-qty';
      s.textContent = ' · ' + plural;
      title.appendChild(s);
    }
  }

  /* 3) Combo ghep (the kp-pk--bundle): gap doan mo ta cua san pham ghep them sau dong
        "Description v"; bam vao moi mo. Doan mo ta do kn-bundle-v*.js dung (.kp-bundle-copy),
        o day chi boc no vao <details>. */
  var cssDone = false;
  function collapseBundleCopy() {
    var copies = root.querySelectorAll('.kp-bundle-with .kp-bundle-copy:not([data-kn-wrapped])');
    if (!copies.length) return;
    if (!cssDone) {
      cssDone = true;
      var st = document.createElement('style');
      st.textContent =
        '.kp-pk--bundle .kp-bundle-more--copy>summary{list-style:none;cursor:pointer;display:block;position:relative;padding-right:24px}' +
        '.kp-pk--bundle .kp-bundle-more--copy>summary::-webkit-details-marker{display:none}' +
        '.kp-pk--bundle .kp-bundle-lbl{display:block;font-size:14.5px;font-weight:700;color:#121212;opacity:.85;line-height:1.4}' +
        '.kp-pk--bundle .kp-bundle-more--copy[open] .kp-bundle-lbl{opacity:1}' +
        '.kp-pk--bundle .kp-bundle-more--copy>summary .kp-bundle-chev{top:5px;width:10px;height:10px}' +
        '.kp-pk--bundle .kp-bundle-more--copy .kp-bundle-copy{margin-top:10px;padding-top:0;border-top:0}';
      document.head.appendChild(st);
    }
    for (var i = 0; i < copies.length; i++) {
      var copy = copies[i];
      copy.setAttribute('data-kn-wrapped', '1');
      var d = document.createElement('details');
      d.className = 'kp-bundle-more kp-bundle-more--copy';
      d.innerHTML = '<summary><span class="kp-bundle-lbl"></span><span class="kp-bundle-chev"></span></summary>';
      var lbl = d.querySelector('.kp-bundle-lbl');
      lbl.textContent = cfg.bundleCopyLabel || 'Description';
      copy.parentNode.insertBefore(d, copy);
      d.appendChild(copy);
      (function (dd, ll) { dd.addEventListener('toggle', function () { ll.textContent = dd.open ? (cfg.bundleCopyOpenLabel || 'Hide description') : (cfg.bundleCopyLabel || 'Description'); }); })(d, lbl);
    }
  }

  /* 4) Chon san pack theo metafield custom.default_pack (vd "2"). Theme danh dau checked cho pack dau
        tien o Liquid; o day doi checked + is-on TRUOC khi kn-product.js (defer, nam trong body) chay,
        nen gia/sticky ve dung pack ngay lan ve dau, khong nhay. Chi lam khi khach chua tu chon. */
  function defaultPack() {
    var want = String(cfg.defaultPack || '').trim(); if (!want) return;
    var radio = root.querySelector('input[name="kp-pack"][value="' + want + '"]'); if (!radio || radio.checked) return;
    var checked = root.querySelector('input[name="kp-pack"]:checked');
    if (checked) { checked.checked = false; var b0 = checked.closest('.kp-pk'); if (b0) b0.classList.remove('is-on'); }
    radio.checked = true; var b1 = radio.closest('.kp-pk'); if (b1) b1.classList.add('is-on');
    /* kn-product.js co the da khoi tao truoc (neu no khong defer) -> bao change de no ve lai gia */
    document.addEventListener('DOMContentLoaded', function () { if (radio.checked) radio.dispatchEvent(new Event('change', { bubbles: true })); });
  }

  function run() { stripLabels(); qtySuffix(); collapseBundleCopy(); }
  defaultPack();
  run();
  var packsEl = document.querySelector('[data-packs]');
  if (packsEl && window.MutationObserver) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 30); })
      .observe(packsEl, { childList: true, subtree: true, characterData: true });
  }
})();
